var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c("div", { staticClass: "drop-shadow-with-top" }, [
        _c("table", { attrs: { id: "header" } }, [
          _c("tr", [
            _vm._m(0),
            _c("td", { attrs: { id: "title", rowspan: "2" } }, [
              _vm._v(" " + _vm._s(_vm.title) + " "),
            ]),
            _c("td", { attrs: { id: "close", rowspan: "2" } }, [
              _c("img", {
                attrs: {
                  id: "close-img",
                  src: require("@/assets/images/close.png"),
                },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              }),
            ]),
          ]),
          _vm._m(1),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("div", {
        staticClass: "sprite folded-corner",
        attrs: { id: "corner-img" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { id: "corner-img-spacer", colspan: "3" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }